const AVATAR_COLORS = [
	'bg-primary-40 text-primary-140',
	'bg-accent-40 text-accent-140',
	'bg-secondary-30 text-secondary-80',
	'bg-primary-50 text-primary-150',
	'bg-accent-50 text-accent-150',
	'bg-secondary-40 text-secondary-90',
] as const

const NAME_PREFIXES = new Set(['dr', 'dra', 'sr', 'sra', 'lic', 'ing'])

function getNameParts(name: string) {
	return name
		.trim()
		.split(/\s+/)
		.filter((word) => {
			const normalized = word.toLowerCase().replace(/\./g, '')
			return normalized.length > 0 && !NAME_PREFIXES.has(normalized)
		})
}

export function getUserInitials(
	name?: string | null,
	username?: string | null,
): string {
	if (name) {
		const parts = getNameParts(name)
		if (parts.length >= 2) {
			const first = parts[0]?.charAt(0) ?? ''
			const last = parts[parts.length - 1]?.charAt(0) ?? ''
			return `${first}${last}`.toUpperCase() || '?'
		}
		if (parts.length === 1) {
			return parts[0]!.slice(0, 2).toUpperCase()
		}
	}

	if (username) {
		return username.slice(0, 2).toUpperCase()
	}

	return '?'
}

export function getUserAvatarColorClass(userId: string): string {
	let hash = 0
	for (let i = 0; i < userId.length; i++) {
		hash = (hash + userId.charCodeAt(i)) % AVATAR_COLORS.length
	}
	return AVATAR_COLORS[hash] ?? AVATAR_COLORS[0]
}

export function getUserDisplayName(
	name?: string | null,
	username?: string | null,
) {
	return name ?? username ?? 'Usuario'
}

export function getUserRoleLabel(
	roles: Array<{ name: string; description?: string }>,
) {
	const primaryRole = roles[0]
	if (!primaryRole) return null
	return primaryRole.description || primaryRole.name
}
